import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as InfoIcon } from './info.svg';

export const Info = IconHOC(InfoIcon);
